import { UnitContentCard } from '@apps-common/apps/portal/pages/units/pages/manage/components'
import { SectionTitle } from '@apps-common/components/common/portal-title'
import { ButtonRoundArrow } from '@apps-common/components/elements/button'
import { VertSpacerLg, VertSpacerMd } from '@apps-common/components/layout'
import { useNavigation } from '@apps-common/hooks/useNavigation'
import { AUTH_CLAIMS, Authorization } from '@apps-common/lib'
import { IUnitGenericDetailsModel } from '@apps-common/types/portal/unit'
import { ROUTE_UNIT_DETAILS } from '@apps-radionet-portal/config/private-routes'

import { ModalButton } from '@apps-common/components/modals'
import { modalSlideUpEnterAnimation, modalSlideUpLeaveAnimation } from '@apps-common/lib/modal-animations'
import classNames from 'classnames'
import { PortalUnitDetailsModal } from '../../../../modals/PortalUnitDetailsModal'
import { UnitDetailsManagementBody } from './UnitDetailsManagementBody'
import { UnitDetailsPortalBody } from './UnitDetailsPortalBody'

interface IProps {
  classes?: string
  status: string
  unit?: IUnitGenericDetailsModel
  loading?: boolean
}

export const UnitDetailsCard: React.FC<IProps> = ({ classes, status, unit, loading }) => {
  const { unitId } = unit || {}
  const { navigateForward } = useNavigation()

  return (
    <UnitContentCard
      classes={classNames(
        classes,
        'h-full bg-transparent px-1 px-5 lg:px-6 !border-none !border-y-[1px] !border-b !py-0 sm:!py-4 sm:bg-surface sm:border'
      )}
    >
      <div className='flex items-center justify-between'>
        <SectionTitle classes='text-text' text='Details' />

        <Authorization
          roles={AUTH_CLAIMS.managementAdmin.roles}
          scopes={AUTH_CLAIMS.managementAdmin.scopes}
          notAuthorizedFallback={
            <ModalButton
              component={PortalUnitDetailsModal}
              classes=''
              componentProps={{
                status,
                unitId
              }}
              enterAnimation={modalSlideUpEnterAnimation}
              leaveAnimation={modalSlideUpLeaveAnimation}
            >
              <ButtonRoundArrow type='div' classes='bg-brand hover:bg-brand' iconClasses='text-on-brand' />
            </ModalButton>
          }
        >
          <ButtonRoundArrow
            classes='bg-brand hover:bg-brand'
            iconClasses='text-on-brand'
            disabled={loading || !unitId}
            callback={() =>
              navigateForward({
                routeUrl: ROUTE_UNIT_DETAILS.buildPath(status, unitId),
                route: ROUTE_UNIT_DETAILS
              })
            }
          />
        </Authorization>
      </div>
      <VertSpacerMd />
      <Authorization
        roles={AUTH_CLAIMS.managementAdmin.roles}
        scopes={AUTH_CLAIMS.managementAdmin.scopes}
        notAuthorizedFallback={<UnitDetailsPortalBody loading={loading} unit={unit} />}
      >
        <UnitDetailsManagementBody loading={loading} unit={unit} />
      </Authorization>
      <VertSpacerLg />
    </UnitContentCard>
  )
}
